export default __webpack_public_path__ + "static/media/19_1_3.c4a082a8.png";